import React from "react";
import ReactECharts from "echarts-for-react";

const MultiLineScales = (props) => {

  const allMonths = Array.from(
    new Set(
      props.data.flatMap(item =>
        item.data.map(d => d.month)
      )
    )
  ).sort();

  const formatNumber = (value) => {
    if (value === null || value === undefined) return "";
    return value.toLocaleString("es-ES");
  };

  const series = props.data.map((section, index) => ({
    name: section.name,
    type: "line",
    smooth: true,
    yAxisIndex: index > 0 ? 1 : 0,

    label: {
      show: true,
      position: "top",
      formatter: (params) => formatNumber(params.value)
    },

    data: allMonths.map(month => {
      const point = section.data.find(
        d => d.month === month
      );

      return point ? point.value : null;
    })
  }));


  const yAxis = [
    {
      type: "value",
      name:
        props.data[0]?.yAxisName ||
        props.data[0]?.name ||
        "",

      position: "left",

      axisLabel: {
        formatter: (value) =>
          formatNumber(value)
      }
    }
  ];

  if (props.data.length > 1) {
    yAxis.push({
      type: "value",

      name:
        props.data[1]?.yAxisName ||
        props.data[1]?.name ||
        "",

      position: "right",

      axisLabel: {
        formatter: (value) =>
          formatNumber(value)
      }
    });
  }


  const options = {
    title: {
      text:
        props.title ||
        "Título del gráfico",

      subtext:
        props.subTitle || "",

      left: "center",
      top: 10
    },

    tooltip: {
      trigger: "axis",

      formatter: (params) => {

        let result =
          `${params[0].axisValue}<br/>`;

        params.forEach(param => {

          if (
            param.value !== null &&
            param.value !== undefined
          ) {

            result +=
              `${param.marker} ` +
              `${param.seriesName}: ` +
              `${formatNumber(param.value)}` +
              `<br/>`;
          }
        });

        return result;
      }
    },

    legend: {
      data: props.data.map(
        item => item.name
      ),

      left: "center",
      top: "bottom"
    },

    xAxis: {
      type: "category",
      data: allMonths,

      axisLabel: {
        interval: 0,
        formatter: (value) => {

          const productionSeries = props.data.find(
            x => x.data.some(d => d.production_month)
          );

          const point = productionSeries?.data.find(
            d => d.month === value
          );

          if (!point?.production_month)
           return `{blueColor|${value}}`;

          return `{blueColor|${value}}\n{greenColor|${point.production_month}}`;
        },

        rich: {
          greenColor: {
            color: 'green',
            fontSize: 12
          },          
          blueColor: {
            color: 'blue',
            fontSize: 12
          }
        }
      }
    },

    yAxis,

    series
  };

  return (
    <ReactECharts
      option={options}
      notMerge={true}
      style={{
        height: props.height || "450px"
      }}
      ref={props.chartRef}
    />
  );
};

export default MultiLineScales;